// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import BridgeMenuController from "./bridge/menu_controller"
application.register("bridge--menu", BridgeMenuController)

import BridgeCalendarController from "./bridge/calendar_controller"
application.register("bridge--calendar", BridgeCalendarController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import PropertyFormController from "./property_form_controller"
application.register("property-form", PropertyFormController)

import ViewToggleController from "./view_toggle_controller"
application.register("view-toggle", ViewToggleController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import KanbanSortableController from "./kanban_sortable_controller"
application.register("kanban-sortable", KanbanSortableController)
